var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React from 'react';
import { DatePicker } from './DatePicker';
import { defaultRangeProps } from './defaults';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
import { CalenderOutlined, WrongFilled } from '@feb-team/legao-icons-react';
import { inputDateParseDate } from './utils';
var RangeDatePicker = /** @class */ (function (_super) {
    __extends(RangeDatePicker, _super);
    function RangeDatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.DateItemChange = function (value, e, type) {
            var nextRangeDate = _this.checkIsExchange(value, type);
            _this.setState({
                isOpenStartPanel: !type ? false : !nextRangeDate[0],
                isOpenEndPanel: !type ? !nextRangeDate[1] : false,
                selectedRange: nextRangeDate,
            }, function () {
                _this.props.onChange(nextRangeDate, e);
            });
        };
        _this.DateItemBeforeChange = function (value, e, type) {
            var nextRangeDate = _this.checkIsExchange(value, type);
            return _this.props.onBeforeChange(nextRangeDate, e);
        };
        _this.checkIsExchange = function (value, type) {
            var nextRangeDate = _this.state.selectedRange;
            var compareDate = __spread(nextRangeDate);
            compareDate[type] = value;
            if (/datetime/.test(_this.props.type) &&
                compareDate[0] &&
                compareDate[1] &&
                inputDateParseDate(compareDate[0]).getTime() > inputDateParseDate(compareDate[1]).getTime()) {
                return [compareDate[1], compareDate[0]];
            }
            return compareDate;
        };
        _this.onMouseEnter = function () {
            _this.setState({
                allowClear: true,
            });
        };
        _this.onMouseLeave = function () {
            _this.setState({
                allowClear: false,
            });
        };
        _this.onClose = function (type) {
            var nextRangeDate = _this.state.selectedRange;
            var data = {};
            if (!type && !nextRangeDate[0] && nextRangeDate[1]) {
                Object.assign(data, { selectedRange: ['', ''] });
            }
            else if (type && !nextRangeDate[1] && nextRangeDate[0]) {
                Object.assign(data, { selectedRange: ['', ''] });
            }
            if (!type) {
                Object.assign(data, { isOpenStartPanel: false });
            }
            else {
                Object.assign(data, { isOpenEndPanel: false });
            }
            _this.setState(data);
        };
        _this.clearText = function (e) {
            var nextRangeDate = _this.state.selectedRange;
            nextRangeDate = [null, null];
            _this.setState({
                selectedRange: __spread(nextRangeDate),
            }, function () {
                _this.datePickerOne.clearText();
                _this.datePickerTwo.clearText();
            });
        };
        var _a = _this.props, value = _a.value, defaultValue = _a.defaultValue;
        var x = _this.props.defaultValue[0];
        _this.state = {
            selectedRange: value[0] || value[1] ? value : defaultValue,
            allowClear: false,
            isOpenStartPanel: false,
            isOpenEndPanel: false,
        };
        return _this;
    }
    RangeDatePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, format = _a.format, disabled = _a.disabled, placeholder = _a.placeholder, type = _a.type, range = _a.range, className = _a.className, style = _a.style;
        var _b = this.state, selectedRange = _b.selectedRange, allowClear = _b.allowClear, isOpenEndPanel = _b.isOpenEndPanel, isOpenStartPanel = _b.isOpenStartPanel;
        var rangeCls = [
            'relative',
            'inline-flex',
            'items-center',
            'pr-px-26',
            'rounded',
            'font-sans',
            'text-gray-600',
            'text-xs',
            'border',
        ];
        var svgBoxCls = [
            'absolute',
            'right-0',
            'top-0',
            'mt-px-8',
            'mr-px-12',
            'w-px-14',
            'fill-black',
            'opacity-20',
            'cursor-pointer',
        ];
        if (disabled) {
            rangeCls.push('bg-gray-100', 'cursor-not-allowed');
        }
        else {
            rangeCls.push('bg-white', 'hover:border-brand-600');
        }
        return (React.createElement(DivTag, { atomics: rangeCls, name: RangeDatePicker.NAME, className: "" + className, style: __assign({}, style) },
            React.createElement(DatePicker, { type: type, bordered: false, showIcon: false, showToday: false, hasConfirmBtn: true, isOpenPanel: isOpenStartPanel, format: format, placeholder: placeholder[0], disabled: disabled, defaultValue: selectedRange[0], defaultRangeValue: selectedRange[1], range: range, onClose: function () { return _this.onClose(0); }, rangeIdx: 1, onChange: function (value, e) { return _this.DateItemChange(value, e, 0); }, onBeforeChange: function (value, e) { return _this.DateItemBeforeChange(value, e, 0); }, ref: function (c) {
                    _this.datePickerOne = c;
                } }),
            React.createElement(SpanTag, null, " \uFF5E "),
            React.createElement(DatePicker, { type: type, bordered: false, showIcon: false, showToday: false, hasConfirmBtn: true, isOpenPanel: isOpenEndPanel, format: format, placeholder: placeholder[1], disabled: disabled, defaultValue: selectedRange[1], defaultRangeValue: selectedRange[0], range: range, rangeIdx: 2, onClose: function () { return _this.onClose(1); }, onChange: function (value, e) { return _this.DateItemChange(value, e, 1); }, onBeforeChange: function (value, e) { return _this.DateItemBeforeChange(value, e, 1); }, ref: function (c) {
                    _this.datePickerTwo = c;
                } }),
            React.createElement(SpanTag, { atomics: svgBoxCls }, !disabled && selectedRange[0] && selectedRange[1] ? (React.createElement(WrongFilled, { className: "range-date-picker-close-btn", onClick: function (e) { return _this.clearText(e); } })) : (React.createElement(CalenderOutlined, null)))));
    };
    RangeDatePicker.defaultProps = defaultRangeProps;
    RangeDatePicker.NAME = 'range-date-picker';
    RangeDatePicker.displayName = 'RangeDatePicker';
    return RangeDatePicker;
}(React.Component));
export { RangeDatePicker };
